export default "__VITE_ASSET__DtCzUT0m__"